class BeforeUnloadService {
    private beforeUnloadHandler: (event: BeforeUnloadEvent) => void;
  
    constructor() {
      this.beforeUnloadHandler = this.handleBeforeUnload.bind(this);
    }
  
    public addBeforeUnloadListener(): void {
      window.addEventListener('beforeunload', this.beforeUnloadHandler);
    }
  
    public removeBeforeUnloadListener(): void {
      window.removeEventListener('beforeunload', this.beforeUnloadHandler);
    }
  
    private handleBeforeUnload(event: BeforeUnloadEvent) {
      event.preventDefault();
      event.returnValue = 'Are you sure you want to leave? You will lose your progress in the form.';
      return 'Are you sure you want to leave? You will lose your progress in the form.';
    }
  }
  
  export default new BeforeUnloadService();
